import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;

  inset: 0;

  z-index: 20;
  background-color: rgba(0, 0, 0, 0.5);
`

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  width: 100vw;

  animation: from-below 0.3s ease forwards;

  @media only screen and (min-width: 800px) {
    left: unset;

    width: unset;
    height: 100vh;

    animation: from-right 0.3s ease forwards;
  }

  @keyframes from-below {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes from-right {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`

export const Content = styled.div`
  position: relative;

  padding: 34px 22px 22px;

  background-color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#fff')};

  border-radius: 24px 24px 0 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .alert-icon {
    width: 84px;
    height: 84px;

    color: rgb(${({ theme }) => theme.primary.base});

    margin-bottom: 16px;
  }

  .title {
    color: rgb(${({ theme }) => theme.grayscale[200]});

    text-align: center;
    font-size: 18px;
    font-weight: 700;
    line-height: 143%;

    margin-bottom: 54px;
  }

  .short-text {
    font-size: 18px;
    font-weight: 500;
    line-height: 120%;

    margin-bottom: 54px;

    max-width: 496px;

    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;

    color: rgb(${({ theme }) => theme.grayscale[100]});
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: 16px;

    width: 100%;

    button {
      border: none;

      padding: 14px;

      border-radius: 4px;

      text-align: center;
      font-size: 16px;
      font-weight: 600;
      line-height: 140%;

      transition: opacity 0.3s ease;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    .delete {
      color: ${({ theme }) => `rgb(${theme.background.low})`};

      background-color: rgb(${({ theme }) => theme.primary.base});
    }

    .cancel {
      background: none;

      border-radius: 4px;
      border-width: 1px;
      border-style: solid;
      border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

      color: ${({ theme }) => `rgb(${theme.primary.base})`};
    }
  }

  @media only screen and (min-width: 800px) {
    border-radius: 6px;

    padding: 50px 40px;

    height: 100vh;
    max-width: 590px;

    border-radius: 0;

    justify-content: flex-start;
    padding-top: 120px;

    .alert-icon {
      width: 72px;
      height: 72px;

      margin-bottom: 24px;
    }

    .title {
      font-size: 22px;
    }

    .short-text {
      margin-bottom: 72px;
    }

    .buttons {
      width: fit-content;

      flex-direction: row;
      justify-content: center;
      gap: 38px;

      button {
        width: 142px;
      }
    }
  }
`
